module.exports = __webpack_public_path__ + "ne.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ne.svg
// module id = 981
// module chunks = 0